import keyMirror from 'keymirror';

export const groupOverviewActionTypes = keyMirror({
	GET_ACTIVE_GROUPS_REQUEST: null,
	GET_ACTIVE_GROUPS_SUCCESS: null,
	GET_ACTIVE_GROUPS_ERROR: null,

	GET_INVITED_GROUPS_REQUEST: null,
	GET_INVITED_GROUPS_SUCCESS: null,
	GET_INVITED_GROUPS_ERROR: null,

	GET_REQUESTED_GROUPS_REQUEST: null,
	GET_REQUESTED_GROUPS_SUCCESS: null,
	GET_REQUESTED_GROUPS_ERROR: null,

	DELETE_GROUP_REQUEST: null,
	DELETE_GROUP_SUCCESS: null,
	DELETE_GROUP_ERROR: null,

	LEAVE_GROUP_REQUEST: null,
	LEAVE_GROUP_SUCCESS: null,
	LEAVE_GROUP_ERROR: null,

	ACCEPT_INVITATION_REQUEST: null,
	ACCEPT_INVITATION_SUCCESS: null,
	ACCEPT_INVITATION_ERROR: null,

	DECLINE_INVITATION_REQUEST: null,
	DECLINE_INVITATION_SUCCESS: null,
	DECLINE_INVITATION_ERROR: null,

	RETRACT_INVITATION_REQUEST: null,
	RETRACT_INVITATION_SUCCESS: null,
	RETRACT_INVITATION_ERROR: null,

	HANDLE_CONFIRMATION_MODAL: null,

	JOIN_GROUP_REQUEST: null,
	JOIN_GROUP_SUCCESS: null,
	JOIN_GROUP_ERROR: null,

	TOGGLE_CREATE_GROUP_MODAL: null,

	GET_EDUCATION_TYPES_REQUEST: null,
	GET_EDUCATION_TYPES_SUCCESS: null,
	GET_EDUCATION_TYPES_ERROR: null,

	GET_INSTITUTES_REQUEST: null,
	GET_INSTITUTES_SUCCESS: null,
	GET_INSTITUTES_ERROR: null,

	GET_SCHOOL_REQUEST: null,
	GET_SCHOOL_SUCCESS: null,
	GET_SCHOOL_ERROR: null,

	SET_GROUP_INFO: null,

	CREATE_GROUP_REQUEST: null,
	CREATE_GROUP_SUCCESS: null,
	CREATE_GROUP_ERROR: null,

	GET_AVAILABLE_SUBJECTS_REQUEST: null,
	GET_AVAILABLE_SUBJECTS_SUCCESS: null,
	GET_AVAILABLE_SUBJECTS_ERROR: null,

	GET_USER_DETAILS_REQUEST: null,
	GET_USER_DETAILS_SUCCESS: null,
	GET_USER_DETAILS_ERROR: null,

	CLEAN_CREATE_GROUP_MODAL_STATE: null,
	CLEAN_GROUP_OVERVIEW_STATE: null,
});

export const CREATE_GROUP_FORM = 'CreateGroupForm';

export const MAX_GROUP_NAME_LENGTH = 70;

export const getActiveGroupOptions = (t) => [
	{
		title: t('group_details.actions.leave_group.action'),
		key: 'leave',
		icon: 'icon-logout',
	},
	{ title: t('general.edit'), key: 'edit', icon: 'icon-create' },
	{
		title: t('modals.add_lists_modal.title'),
		key: 'add_lists',
		icon: 'icon-add',
		className: 'hide-s hide-m hide-l',
	},
	{
		title: t('group_details.actions.add_members'),
		key: 'add_users',
		icon: 'icon-person-add',
		className: 'hide-s hide-m hide-l',
	},
	{
		title: t('group_details.actions.how_group_works'),
		key: 'navigate_to_zendesk',
		icon: 'icon-help',
	},
	{
		title: t('group_details.actions.delete_group.action'),
		key: 'remove',
		icon: 'icon-trash-can',
	},
	{
		title: t('group_details.actions.add_managers'),
		key: 'add_manager',
		icon: 'icon-person-manager',
	},
];

export const getInvitedGroupOptions = (t) => [
	{ title: t('group_details.actions.delete_invitation'), key: 'decline' },
];

export const getRequestedGroupOptions = (t) => [
	{ title: t('group_details.actions.withdraw_request'), key: 'retract' },
];

export const getRequestedToJoinGroupOptions = (t) => [
	{ title: t('group_details.actions.request_to_join_group'), key: 'request_to_join' },
];
